// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../containers/Settings'));

export default class Settings extends TabLoader {
  public loadTab = (tabId?: string | number): any => {
    window.store.dispatch(removeAll());

    const tabData: TabConfig = {
      id: String(tabId || window.getStr()),
      title: 'My Account',
      active: true,
      component: Component,
      props: {},
    };

    window.store.dispatch(addTab(tabData));
  };
}
